// extracted by mini-css-extract-plugin
export var carrierTab = "_3k-0";
export var carrierTabActive = "_3k-1 _3k-0";
export var carrierTabInactive = "_3k-2 _3k-0";
export var carrierTabLabel = "_3k-3";
export var carrierTabLabelActive = "_3k-4 _3k-3";
export var carrierTabLabelInactive = "_3k-5 _3k-3";
export var carrierTabPercentage = "_3k-6";
export var carrierTabPercentageActive = "_3k-7 _3k-6";
export var carrierTabPercentageInactive = "_3k-8 _3k-6";
export var carrierTabWinnable = "_3k-9";
export var carrierTabWinnableActive = "_3k-a _3k-9";
export var carrierTabWinnableInactive = "_3k-b _3k-9";
export var comparisonContainer = "_3k-d";
export var missingRateButton = "_3k-n";
export var missingRateButtonActive = "_3k-o _3k-n";
export var missingRateButtonInactive = "_3k-p _3k-n";
export var missingRateButtonLabel = "_3k-q";
export var missingRateButtonLabelActive = "_3k-r _3k-q";
export var missingRateButtonLabelInactive = "_3k-s _3k-q";
export var sidebar = "_3k-c";
export var strategyButton = "_3k-e";
export var strategyButtonActive = "_3k-f _3k-e";
export var strategyButtonDescription = "_3k-k";
export var strategyButtonDescriptionActive = "_3k-l _3k-k";
export var strategyButtonDescriptionInactive = "_3k-m _3k-k";
export var strategyButtonInactive = "_3k-g _3k-e";
export var strategyButtonLabel = "_3k-h";
export var strategyButtonLabelActive = "_3k-i _3k-h";
export var strategyButtonLabelInactive = "_3k-j _3k-h";
export var unitToggleButton = "_3k-t";
export var unitToggleButtonActive = "_3k-u _3k-t";
export var unitToggleButtonInactive = "_3k-v _3k-t";
export var unitToggleButtonLabel = "_3k-w";
export var unitToggleButtonLabelActive = "_3k-x _3k-w";
export var unitToggleButtonLabelInactive = "_3k-y _3k-w";